import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Observer } from 'rxjs';
import { isExists, isNotExists } from 'src/shared/journal/utils';

@Component({
  selector: 'app-table-cell-actions-panel',
  templateUrl: './table-cell-actions-panel.component.html',
  styleUrls: ['./table-cell-actions-panel.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableCellActionsPanelComponent implements OnInit, ICellRendererAngularComp {
  params!: ICellRendererParams & { selectedId?: Observer<any> };
  actions: any[] = [];
  row: any;

  actionHandler!: (row: any, action: any) => void;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {}

  agInit(params: ICellRendererParams<any, any>): void {
    this.updateByParams(params);
  }

  refresh(params: ICellRendererParams<any, any>): boolean {
    this.cdr.detectChanges();
    return true;
  }

  call(action: any, event: MouseEvent) {
    if (isExists(this.actionHandler)) {
      this.actionHandler(this.row, action);
    } else {
      action.callback();
    }
    event.stopImmediatePropagation();
    event.preventDefault();
  }

  private updateByParams(params: ICellRendererParams) {
    this.params = params;
    this.actions = isNotExists(params.value) ? [] : !Array.isArray(params.value) ? [params.value] : params.value;
    this.actionHandler = params.colDef?.cellRendererParams?.actionHandler;
    this.row = params.data;
    this.cdr.detectChanges();
  }
}
